import * as React from 'react';
import './../styles/Dashboard.css';
import NewPersonalization from '../components/Dashboard/NewPersonalization.js';
import NewPreset from '../components/Dashboard/NewPreset.js';
import ProductSync from '../components/Dashboard/ProductSync.js';
import Search from '../components/Dashboard/Search.js';
import ProductTable from '../components/Dashboard/ProductTable.js';

function Dashboard() {
    return(
        <div className="dashboard-wrapper">
            <div className="dashboard-header">
                <div className="actions-row">
                    <div className="actions-group">
                        <NewPersonalization />
                        {/* <NewPreset /> */}
                        <ProductSync />
                    </div>
                    <div className="actions-group">
                        <Search />
                    </div>
                </div>
            </div>
            <div className="dashboard-body">
                <h1 className="dashboard-title">DASHBOARD</h1>
                <ProductTable dashboard={true} />
            </div>
        </div>
    )
}

export default Dashboard;